import { Collateral } from "../Types";
import { format } from "./number";
import { TroveMappings, Decimal } from "@liquity/lib-base";

const toastProps = {
  status: "error",
  duration: 4000,
  isClosable: true,
  position: "top-right"
};

export const validateDeposit = (
  toast: any,
  mode: "deposit" | "withdraw",
  balance: number,
  deposit: number,
  valueChange: number,
  successFunction: any
) => {
  // console.log(valueChange);
  if (valueChange === undefined) {
    toast({
      title: "Invalid Deposit",
      description: "Please enter a deposit or withdrawal value.",
      ...toastProps
    });
  } else if (valueChange == 0) {
    toast({
      title: "Invalid Deposit",
      description: "Please enter a value greater than 0.",
      ...toastProps
    });
  } else if (mode === "withdraw" && valueChange > deposit) {
    toast({
      title: "Invalid Deposit",
      description: "You cannot withdraw more than your current deposit.",
      ...toastProps
    });
  } else if (mode === "deposit" && valueChange > balance) {
    toast({
      title: "Invalid Deposit",
      description: "You cannot deposit more than your current balance.",
      ...toastProps
    });
  } else {
    successFunction();
  }
};

const dec = (val: string, scale: any) => {
  let zerosCount = 0;

  if (scale == "ether") {
    zerosCount = 18;
  } else if (scale == "finney") zerosCount = 15;
  else {
    zerosCount = scale;
  }

  const strVal = val.toString();
  const strZeros = "0".repeat(zerosCount);

  return strVal.concat(strZeros);
};

export const getVCChanges = (
  collateral: Collateral[],
  values: { [key: string]: any },
  price: TroveMappings
) => {
  let tempVCInputs: TroveMappings = {};
  let tempVCOutputs: TroveMappings = {};
  const depositedCollateral = collateral.filter(
    ({ token }) => values[token + "mode"] === "deposit" && values[token]
  );
  const withdrawnCollateral = collateral.filter(
    ({ token }) => values[token + "mode"] === "withdraw" && values[token]
  );
  // console.log('dddd', collateral, values, price);
  depositedCollateral.map(
    ({ address, token, safetyRatio, decimals }) =>
      (tempVCInputs[address] = Decimal.fromWithPrecision(
        !isNaN(parseFloat(values[token])) ? values[token] : 0,
        decimals
      ))
  );
  withdrawnCollateral.map(
    ({ address, token, safetyRatio, decimals }) =>
      (tempVCOutputs[address] = Decimal.fromWithPrecision(
        !isNaN(parseFloat(values[token])) ? values[token] : 0,
        decimals
      ))
  );

  return [tempVCInputs, tempVCOutputs];
};
